import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const MuiTableCell: {
    styleOverrides: ComponentsOverrides<Theme>['MuiTableCell'];
    defaultProps?: ComponentsProps['MuiTableCell'];
    variants?: ComponentsVariants['MuiTableCell'];
} = {
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            padding: theme.spacing(2),
            [theme.breakpoints.down(ownerState.hide || 0)]: {
                display: 'none',
            },
        }),
        head: ({ theme }) => ({
            ...theme.typography.caption,
            color: theme.palette.grey[800],
            height: 49,
            padding: theme.spacing(2, 2, 1.5),
            borderBottom: `1px solid ${theme.palette.grey[500]}`,
        }),
        body: ({ theme }) => ({
            ...theme.typography.body1,
            height: theme.spacing(9),
            padding: theme.spacing(0, 2),
        }),
        footer: ({ theme }) => ({
            ...theme.typography.body1,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.grey[800],
            height: theme.spacing(6),
            padding: theme.spacing(2, 2),
            borderTop: `1px solid ${theme.palette.grey[500]}`,
            borderBottom: 'none',
        }),
    },
};
